import { io, Socket } from 'socket.io-client';
import type { ServerToClientEvents, ClientToServerEvents, Side } from '~shared/types';

export type GameSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

class SocketClient {
  private _socket: GameSocket | null = null;
  mySide: Side | null = null;

  connect(serverUrl: string): GameSocket {
    if (this._socket?.connected) return this._socket;
    this._socket = io(serverUrl, { transports: ['websocket'] });
    return this._socket;
  }

  get socket(): GameSocket {
    if (!this._socket) throw new Error('SocketClient: not connected');
    return this._socket;
  }

  get connected(): boolean {
    return this._socket?.connected ?? false;
  }
}

export const socketClient = new SocketClient();
